import React, { useState } from 'react';
import Button from './Button';
import './GetQuoteForm.css';
import emailjs from '@emailjs/browser'; // Import EmailJS

const GetQuoteForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    projectType: '',
    projectDetails: '',
    estimatedStartDate: '', // Important for scheduling
    estimatedBudget: '',   // Important for aligning expectations
    propertyType: '',      // Important for tailoring the quote
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, attachments: e.target.files[0] }); // Simple single file upload
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceID = 'service_tq251hq';
    const templateID = 'template_md1wxmm';
    const publicKey = 'ADYRasjhLszJ4pSNJ';

    // Consider using FormData to send files
    const form = e.target;

    emailjs.sendForm(serviceID, templateID, form, publicKey)
      .then((result) => {
        console.log(result.text);
        alert('Thank you for your quote request! We will be in touch soon.');
      }, (error) => {
        console.log(error.text);
        alert('There was an error submitting your request. Please try again.');
      });

    setFormData({
      name: '',
      email: '',
      phone: '',
      city: '',
      projectType: '',
      projectDetails: '',
      estimatedStartDate: '',
      estimatedBudget: '',
      propertyType: '',
    });
  };

  return (
    <div className="get-quote-form-container">
      <h2>Get a Free Quote</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label htmlFor="city">City</label>
          <input type="text" id="city" name="city" value={formData.city} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label htmlFor="projectType">Project Type</label>
          <select id="projectType" name="projectType" value={formData.projectType} onChange={handleChange} required>
            <option value="">Select...</option>
            <option value="new-construction">New Construction</option>
            <option value="renovation">Renovation</option>
            <option value="extension">Extension</option>
            <option value="custom-build">Custom Build</option>
            <option value="interior-design">Interior Design</option>
            <option value="architectural-design">Architectural Design</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="estimatedStartDate">Estimated Start Date</label>
          <input type="date" id="estimatedStartDate" name="estimatedStartDate" value={formData.estimatedStartDate} onChange={handleChange} />
          <small>When are you hoping to begin the project?</small>
        </div>
        <div className="form-group">
          <label htmlFor="estimatedBudget">Estimated Budget (Optional)</label>
          <input type="text" id="estimatedBudget" name="estimatedBudget" value={formData.estimatedBudget} onChange={handleChange} placeholder="e.g., ₹50,000 - ₹1,00,000" />
          <small>Providing a budget helps us tailor the quote to your needs.</small>
        </div>
        <div className="form-group">
          <label htmlFor="propertyType">Property Type (if applicable)</label>
          <select id="propertyType" name="propertyType" value={formData.propertyType} onChange={handleChange}>
            <option value="">Select...</option>
            <option value="residential">Residential</option>
            <option value="commercial">Commercial</option>
            <option value="industrial">Industrial</option>
            <option value="land">Land</option>
            {/* Add more property types as needed */}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="projectDetails">Project Details</label>
          <textarea id="projectDetails" name="projectDetails" value={formData.projectDetails} onChange={handleChange} rows="4" required></textarea>
        </div>
        <Button type="submit">Submit Request</Button>
      </form>
    </div>
  );
};

export default GetQuoteForm;